import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map, shareReplay, switchMap } from 'rxjs';

import { ApiService } from '@portal/app/shared/services/api.service';
import {
  BrandRow,
  CurrentStatus,
  PermissionResponse
} from '@portal/app/shared/types';

@Injectable({
  providedIn: 'root'
})
export class BrandRowsService {
  constructor(private apiService: ApiService) {}

  private readonly refresh$ = new BehaviorSubject<void>(undefined);

  readonly brandRows$: Observable<BrandRow[]> = this.refresh$.pipe(
    switchMap(() =>
      this.apiService
        .getClients()
        .pipe(map((resp) => this.toBrandRows(resp?.clients ?? [])))
    ),
    shareReplay({ bufferSize: 1, refCount: false })
  );

  public buildBrandRows(): Observable<BrandRow[]> {
    return this.brandRows$;
  }

  public refresh(): void {
    this.refresh$.next();
  }

  private toBrandRows(clients: PermissionResponse['clients']): BrandRow[] {
    const rows: BrandRow[] = [];
    for (const client of clients) {
      if (client.status !== CurrentStatus.active) {
        continue;
      }
      for (const brand of client.brands) {
        if (brand.status !== CurrentStatus.active) {
          continue;
        }
        rows.push({
          client,
          brand,
          clientId: brand.clientId,
          brandId: brand.brandId,
          name: brand.brandName,
          status: brand.status
        });
      }
    }
    return rows;
  }
}
